import { Component, Input } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { LoginService } from '../login/service/login.service';
import { DomSanitizer } from '@angular/platform-browser';
import { AppComponent } from '../../app.component';
import * as CryptoJS from 'crypto-js';
import { HttpErrorResponse } from '@angular/common/http';
import { SettingsService } from '../../views/layout/settings/service/settings.service';
import { NotifierService } from 'angular-notifier';
import { MainService } from '../../views/layout/main/service/mainservice';
import { error } from 'jquery';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent {

  myOptions:any = {};
  myOptions2:any={};
  myOptions3:any={};
  sideExp:boolean=true;
  DropDownArrow = 'down';
  updatedUserName:string="";
  profileData:any;
  profile!:boolean;
  userimage:any;
 userDetails:any;
  clientcodeId:any;
  userid:any;
  dateTime!: Date;
  selectedApps:string="";
  private readonly notifier: NotifierService;
  subscription: Subscription;
  browserRefresh:boolean = false;
 constructor(private router:Router,private service:LoginService,private notifierService: NotifierService,private sanitizer: DomSanitizer,private settingService:SettingsService,private mainService:MainService){
   this.notifier = notifierService;
   this.subscription = router.events.subscribe((event) => {
        if (event instanceof NavigationStart) {
          this.browserRefresh = !router.navigated;
        }
    });
 }
  ngOnInit() {
   this.myOptions2 = {
      placement: 'right',
      display: this.sideExp,
      hideDelay: 0,
      showDelay: 400,
      maxWidth: 200,
      trigger: 'hover',
      shadow: true,
      theme: 'light',
    };
    this.getProfileData();
     let user:any = localStorage.getItem("user");
    if(!user){
      this.getUser();
        // var data = CryptoJS.AES.decrypt(user,this.service.enCryptKey).toString(CryptoJS.enc.Utf8);
        //  this.userDetails = JSON.parse(data);
        //  this.profile=false;
    } else{
      var data = CryptoJS.AES.decrypt(user,this.service.enCryptKey).toString(CryptoJS.enc.Utf8);
         this.userDetails = JSON.parse(data);
         console.log('user details',this.userDetails)
         this.service.userDetails = JSON.parse(data);
         this.profile=true;
    }
   
 
    this.settingService.companylogoBS.subscribe((response:any)=>{
      if(response.hasOwnProperty("value") && response['value']=="userimage"){
          this.getProfileData();
      }
    });
  
    this.mainService.selectedAppsBS.subscribe(res=>{
        if(res.hasOwnProperty('name')){
         this.mainService.selectedApp=res;    
       
            if(res['name'] !='ai-assist' && res['name'] !='reports'){
              this.selectedApps=res['name'];
              this.router.navigateByUrl(res['url']);
            }else{
              window.open(res['url'],'target = "_blank"');
            }

       }
      
    });

    if(localStorage.getItem('selectedApps')){
      this.selectedApps=localStorage.getItem('selectedApps')?.toString() || "";
    }

   
    
  }

  ngOnChanges() {
    this.myOptions = {
      placement: 'right',
      display: this.sideExp,
      hideDelay: 0,
      showDelay: 200,
      maxWidth: 200,
      trigger: 'hover',
      shadow: true,
    };
    this.myOptions3 = {
      placement: 'right',
      display: this.sideExp,
      hideDelay: 0,
      showDelay: 200,
      maxWidth: 200,
      trigger: 'hover',
      shadow: true,
    };
   // this.userName = this.updatedUserName;
  }

  expandCollaspse(){
    this.sideExp = !this.sideExp;
    this.myOptions = {
      placement: 'right',
      display: this.sideExp,
      hideDelay: 0,
      showDelay: 200,
      maxWidth: 200,
      trigger: 'hover',
      shadow: true,
    };
    this.myOptions3 = {
      placement: 'right',
      display: this.sideExp,
      hideDelay: 0,
      showDelay: 200,
      maxWidth: 200,
      trigger: 'hover',
      shadow: true,
    };
  }

  showHideDropDown(value: string) {
    if (value === 'up') {
      this.DropDownArrow = value;
    } else if (value === 'down') {
      this.DropDownArrow = value;
    }
  }


  getProfileData(){
    this.service.getProfile().subscribe({
      next: (response:any) => {
         this.profileData = response;
          //this.profile=false;
         this.userDetails['name']=response['name'];
         if(this.profileData.user_image==""){
            this.profile=false;
            
         }else{
            this.profile=true;
            const imageBase64 = this.profileData.user_image.replace(/b'|'/g, '');
        this.userimage = this.sanitizer.bypassSecurityTrustResourceUrl(
          'data:image/jpg;base64,' + imageBase64
        );
         }
        // this.imageSrcData = this.profileData.user_image;
        // const imageBase64 = this.profileData.user_image.replace(/b'|'/g, '');
        // this.imageSrc = this.sanitizer.bypassSecurityTrustResourceUrl(
        //   'data:image/jpg;base64,' + imageBase64
        // );
       
      },
      error: (err) => {
        console.log('profile error');
         this.profile=false;
       
      },
    });
  }

  

  getUser(){
    this.service.getUser().subscribe({
      next:(response:any)=>{
        this.userDetails = response;
        var data = CryptoJS.AES.encrypt(JSON.stringify(response),this.service.enCryptKey);
          localStorage.setItem("user",data.toString());
           this.userid=response['userid'];
        this.clientcodeId = this.userDetails['cli_code']['$oid'];
        this.service.userDetails = response;
        if(!this.userDetails.hasOwnProperty("plan_id")){
          this.router.navigate(['/dashboard']);
          return;
        }
        if (new Date(this.userDetails?.end_date).getTime() < new Date(this.dateTime).getTime() && this.userDetails?.plan_id === 1) {
           this.router.navigate(['/dashboard']);
        } else {
           this.router.navigate(['/dashboard']);
        }
       
      },
      error:(error:HttpErrorResponse)=>{
        this.notifier.notify('error',error.error['message']);
      }
    });
  }

  clearStorage() {
    this.service.logout(this.userid).subscribe(
      {
        next:(res:any)=>{
         this.notifier.notify('default','You have successfully logged out.');
        localStorage.clear();
        sessionStorage.clear();
        window.location.reload();
        this.router.navigate(['login']);
    },
      error:(error:HttpErrorResponse)=>{

      }
    });
    
  }

  ngAfterViewInit(){
    if(!this.browserRefresh){
      this.mainService.selectedAppsBS.next(this.selectedApps);
    }
    if(localStorage.getItem('selectedApps')){
      this.selectedApps=localStorage.getItem('selectedApps')?.toString() || "";
    }
  }

}
